export const ticketStatuses = [
  {
    stageId: 1,
    key: 'new',
    color: '#34C759',
  },
  {
    stageId: 2,
    key: 'inProgress',
    color: '#007AFF',
  },
  {
    stageId: 3,
    key: 'onHold',
    color: '#F97315',
  },
  {
    stageId: 4,
    key: 'solved',
    color: '#D5DC2E',
  },
  {
    stageId: 5,
    key: 'cancelled',
    color: '#B9B9B9',
  },
];
